module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.0.0.box.394.358.1719.177.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "font-variant": "small-caps"
    },
    attrs: {
      "id": "para.23.0.0.box.394.358.1719.89.q.70"
    }
  }, [_vm._v("Brig. Gen. Lawrence O'Brian Branch")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.23.0.1.box.940.471.630.64.q.80"
    }
  }, [_vm._v("Headquarters Flag")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.23.1.0.box.370.664.1768.1052.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0021.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.5.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.2.0.box.314.1856.1879.982.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.2.0.box.314.1856.1879.348.q.60"
    }
  }, [_vm._v("Lawrence O'Brian Branch enlisted as a private in the Raleigh Rifles in April 1861. The experience this 41-year-old son of North Carolina brought would take him quickly to positions of leadership. He was born in 1820 in Halifax, North Carolina, taken by his parents to Tennessee, and orphaned at the age of seven. He was brought back to North Carolina by his uncle and guardian, Gov. John Branch.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.2.1.box.314.2228.1876.174.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.5.1.0"
    }
  }), _vm._v("When Governor Branch was appointed Secretary of the Navy in 1829, Lawrence went with him to Washington, where he studied under Salmon P. Chase. He graduated with first honors from Princeton at the age of 18.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.2.2.box.314.2415.1879.235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.5.2.0"
    }
  }), _vm._v("He resided for a while in Florida and participated in the Seminole War. Returning to his home state, he became president of the Raleigh & Gaston Railroad and in 1855 was elected to Congress. After the invasion of Charleston harbor on January 9, 1861, Branch became an ardent secessionist.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.2.3.box.314.2664.1879.174.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.5.3.0"
    }
  }), _vm._v("He did not remain a private long. On May 20, the date of North Carolina's secession, he accepted the office of state quartermaster-general. In this capacity, he was instrumental in issuing the first North Carolina flags to State"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.1.0.box.303.354.1885.236.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _vm._v("\nTroops. On June 22, 1861, an ordinance was written establishing the pattern of a new state flag, and in August, Branch, in his role as quartermaster-general, ordered the purchase of ten silk flags. These were issued to the first ten regiments of State Troops.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.24.0.0.box.1326.1212.768.1058.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.2.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0022.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.2.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.24.1.0.box.303.354.1888.2300.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.1.box.307.603.1881.361.q.60"
    }
  }, [_vm._v("Resigning his office for field service, he was elected colonel of the 33rd Regiment. In January 1862, he was promoted to brigadier general. His brigade consisted of the 7th, 18th, 28th, 33rd, and 37th Regiments. He led his brigade at New Berne, Mechanicsville, Cold Harbor, Frayser's Farm, and Malvern Hill, earning fame for his courage and coolness in battle. He led his men through Cedar Run, 2nd Manassas, Fairfax Court House, and Harpers Ferry.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.2.box.306.979.1882.489.q.60"
    }
  }, [_vm._v("From Harpers Ferry, Branch's brigade, as a part of A. P. Hill's famous division, rushed to the aid of General Lee at Sharpsburg, arriving in time to drive Burnside's Corps from the field. Soon after this success, a group of officers, Branch included, were consulting with General Hill when a sharpshooter's bullet struck the gallant North Carolinian in the head, killing him instantly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.3.box.308.1482.871.480.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.3.0"
    }
  }), _vm._v("Of Lawrence O'B. Branch, General Hill said, \"The Confederacy has to mourn the loss of a gallant soldier and accomplished gentleman. He was my senior brigadier, and one to whom I could have intrusted the command of the division, with all confidence.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.4.box.305.1983.875.361.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.4.0"
    }
  }), _vm._v("General Branch's Headquarters flag was of the Confederate 1st National pattern. The flag is missing considerable material "), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.5.0"
    }
  }), _vm._v("but was probably 48\" (hoist) x 72\" (fly) when new. The blue canton is 32\" square and")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.1.5.box.309.2357.1882.297.q.60"
    }
  }, [_vm._v("displays twelve 5\" diameter stars. These stars, with slightly rounded rays, are a feature of the flag of the 33rd North Carolina State Troops, and it is likely that each regiment of Branch's Brigade was issued a similar flag. The circle of stars has within it the embroidered inscription \"Gen. L. O'B. Branch/1862/N.C.\" in script letters.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.2.0.box.384.2730.1160.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.2.0.box.384.2730.1160.47.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.3.0.0"
    }
  }), _vm._v("North ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carolina ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Museum ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("History, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Raleigh, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("N.C. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a7ee21e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0023.vue
// module id = 66
// module chunks = 0